<template>
  <div id="app">
    <div class="d-flex col justify-content-center">
      <div class="d-flex flex-column justify-content-center pt-4">
        <img
          class="zed-games-logo"
          src="./assets/images/zed-games-logo.png"
          alt=""
        />
      </div>
    </div>
    <div v-if="showWinDailyBanner" class="d-flex col justify-content-center pt-1">
      <img
        class="col-12 col-sm-8 col-md-6 col-lg-4 col-xl-4 header-image" src="./assets/images/win-icon.png"
        alt=""
      />
    </div>
    <div class="row justify-content-center pt-1">
      <router-view
        class="col-12 col-sm-8 col-md-6 col-lg-4 col-xl-4"
      ></router-view>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  name: "App",
  computed: {
    ...mapState(["showWinDailyBanner"]),
  },
  methods: {
    ...mapMutations(["setShowWinDailyBanner"]),
  },
};
</script>

<style>
#app {
  background-image: url('./assets/images/triangle-bg.png');
  background-size: cover;
  min-height: 100vh;
}

.header-image {
  height: auto;
}

@font-face {
  font-family: "MTNBrighterSans";
  src: local("MTNBrighterSans"),
  url(./assets/fonts/MTNBrighterSans-Regular.ttf) format("truetype");
}
</style>
